import * as z from "../../..";
import * as ui from "../../../../app/core/ui";
import addGroupView from "./addGroup.view";

var filterView = () => new ui.Container({
    id: "FilterContainer",
    style: "display: flex; flex-direction: column;",
    components: [
        addGroupView(0),
    ]
});

export default filterView;
